import aes from "crypto-js/aes";
import enc from "crypto-js/enc-utf8";

const getParameterFromURL = (name: string, url?: string): string => {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, '\\$&');
	const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, '+'));
};

const EMAIL_DECRYPTION_KEY = "9213812384";

const tryDecryptEmail = (cipherText: string): string | null => {
  try {
    const decrypted = aes.decrypt(cipherText, EMAIL_DECRYPTION_KEY).toString(enc);
    const email = decrypted.trim();
    return email;
  } catch {
    return null;
  }
};

export const extractEmailFromUrl = (): string => {
  const encryptedEmail = getParameterFromURL("ev");
  if (encryptedEmail) {
    const email = tryDecryptEmail(encryptedEmail);
    if (email) return email;
  }

  const plainEmailParam = getParameterFromURL("email");
  if (plainEmailParam) {
    const decoded = decodeURIComponent(plainEmailParam).trim();
    return decoded;
  }

  return "";
};
